module.exports = __webpack_public_path__ + "static/media/mahdi.7ae22c8c.webp";